import { Model, Response } from 'vue-mc'
import _ from 'lodash';

export default class BaseModel extends Model {
  no_data_message = "Data not available.";
  data_deleted_message = "Data were deleted.";

  options() {
    const options = super.options() || {};

    options.methods = this.methods();

    return options;
  }
  modelName() {
    return null;
  }
  formattedName() {
    let name = this.modelName();

    if (name !== null) {
      let split = name.split(/[-_]/);

      split = split.filter(function (el) {
        return el != null;
      });
      name = split.join(' ');
    }

    return name;
  }
  icon() {
    return null;
  }
  static iconStatic() {
    const self = new this();

    return self.icon();
  }
  defaults() {
    return {}
  }
  mutations() {
    return {}
  }
  validation() {
    return {}
  }
  methods() {
    return {
      fetch: "GET",
      fetchConnection: "GET",
      save: "POST",
      update: "PUT",
      create: "POST",
      delete: "DELETE"
    }
  }
  getMethod(key) {
    const methods = this.methods();

    return methods[key];
  }
  routes() {
    return {}
  }
  createRequest(config) {
    const token = localStorage.getItem('auth__access_token');

    if (token) {
      config.headers = config.headers || {};
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return new super.createRequest(config);
  }
  fetchConnection(connection, params) {
    !this.connection_requests && (this.connection_requests = {});

    const method = this.getOption('methods.fetchConnection');
    const route = this.getRoute('fetchConnection');
    const url = this.getURL(route, {
      id: this.get(this.getOption('identifier')),
      connection
    });

    return this.connection_requests[connection] = this.createRequest({method, url, params}).send().then((response) => {
      this.emit('fetchConnection', { error: null, connection: connection });
      
      return response instanceof Response
        ? response.response
        : response;
    });
  }
  getRelatedCollection(collection, key) {
    if(!this.id) return // dont get relations if no ID
    
    !this.connection_cache && (this.connection_cache = {})
    
    if (this.connection_cache && this.connection_cache[key]) {
      const collection = this.connection_cache[key];

      this.emit('relatedCollectionLoaded', { error: null, key, collection });
      
      return this.connection_cache[key];
    }

    const value = this.get(key);

    if (value && value.length && Array.isArray(value)) {
      value.forEach((insert) => {
        const model = (new (collection.model())(insert));

        collection.add(model);
      });
      this.emit('relatedCollectionLoaded', {error: null, key, collection});
    } else if(!value) {
      let params = collection.getFilter();
      params.connection = key;
      this.fetchConnection(key).then((response) => {
        this.set(key, response.data);
        let models = collection.getModelsFromResponse(response);
        collection.replace(models);
        this.emit('relatedCollectionLoaded', {error: null, key, collection});
      });
    }
    this.connection_cache[key] = collection;

    return this.connection_cache[key];
  }
  getRelatedModel(model, key) {

    if(!this.id) return // dont get relations if no ID

    !this.connection_cache && (this.connection_cache = {});

    if (this.connection_cache[key]) {
      this.emit('relatedModelLoaded', { error: null, key, model: this.connection_cache[key] });
      
      return this.connection_cache[key];
    }

    const value = this.get(key);

    if (value) {
      this.connection_cache[key] = ((value instanceof BaseModel) ? value : (new model(value)));

      this.emit('relatedModelLoaded', { error: null, key, model: this.connection_cache[key] });
      
      return this.connection_cache[key];
    } else {
      this.set(key, (new model()));
      this.connection_cache[key] = this.get(key);
      this.fetchConnection(key).then((response) => {
        this.get(key).set((response.data && Array.isArray(response.data) ? (response.data.length ? response.data[0] : null) : response.data));
        this.emit('relatedModelLoaded', {error: null, key, model: this.connection_cache[key]});
      });

      return this.connection_cache[key];
    }
  }
  nullStringMutator(val) {
    return _.toString(val) || null;
  }
  nullNumberMutator(val) {
    return _.toNumber(val) || null;
  }
   nullBoolMutator(val) {
    return typeof val !== 'undefined' ? !!val : null;
  }
  nullArrayMutator(val) {
    return val.length ? val : null;
  }
  nullObjectMutator(val) {
    return _.isObject(val) ? val : null;
  }
  cloneAttributes(exclude_obj, exclude_arr, exclude_keys) {
    exclude_obj = !!exclude_obj;
    exclude_arr = !!exclude_arr;
    exclude_keys = _.concat(
      [
        'created_at',
        'updated_at',
        'deleted_at'
      ],
      _.isArray(exclude_keys) ? exclude_keys : []
    );

    const cloned = {};

    for (const key of Object.keys(this.attributes)) {
      if (
        !exclude_keys.includes(key)
        && (
          !exclude_obj || (exclude_obj && typeof this.attributes[key] !== 'object')
        )
        && (
          !exclude_arr || (exclude_arr && !_.isArray(this.attributes[key]))
        )
      ) {
        cloned[key] = this.attributes[key];
      }
    }

    return cloned;
  }
}
